import { useEffect, useMemo, useState } from 'react';
import { api } from './api';

// Bảng "Thêm danh mục": ảnh + tên danh mục
export default function AddCategoryDialog({ onDone, onCancel }) {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const preview = useMemo(() => (file ? URL.createObjectURL(file) : ''), [file]);
  useEffect(() => () => preview && URL.revokeObjectURL(preview), [preview]);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    let category;
    try {
      category = await api.createCategory({ name: name.trim() });
    } catch (err) {
      setError(err.message); // vd tên đã có -> giữ bảng mở để sửa
      setSaving(false);
      return;
    }

    // Danh mục đã tạo; ảnh lỗi thì vẫn báo nhưng không tạo lại danh mục
    let imageError = '';
    if (file) {
      try {
        await api.uploadCategoryImage(category.id, file);
      } catch (err) {
        imageError = err.message;
      }
    }
    setSaving(false);
    onDone({ category, imageError });
  };

  return (
    <div className="dialog-backdrop" onClick={saving ? undefined : onCancel}>
      <form className="dialog add-category" onClick={(e) => e.stopPropagation()} onSubmit={save} aria-label="Thêm danh mục">
        <h2>Thêm danh mục</h2>

        <div className="field">
          Ảnh danh mục
          <label className={`category-image-pick ${preview ? 'has-image' : ''}`}>
            {preview ? <img src={preview} alt="" /> : <span>+ Chọn ảnh</span>}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => {
                setFile(e.target.files[0] || null);
                e.target.value = '';
              }}
            />
          </label>
          {file && (
            <button type="button" className="link-btn" onClick={() => setFile(null)}>
              Bỏ ảnh
            </button>
          )}
        </div>

        <label>
          Tên danh mục <span className="required">*</span>
          <input required autoFocus maxLength={100} value={name} onChange={(e) => setName(e.target.value)} />
        </label>

        {error && <p className="error">{error}</p>}

        <div className="dialog-actions">
          <button type="button" onClick={onCancel} disabled={saving}>
            Huỷ
          </button>
          <button type="submit" className="primary" disabled={saving || !name.trim()}>
            {saving ? 'Đang lưu...' : 'Lưu'}
          </button>
        </div>
      </form>
    </div>
  );
}
